import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { AdminNotificationsToolbarComponent } from './admin-notifications-toolbar.component';
import { ProfileService } from 'app/main/pages/profile/profile.service';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ToolbarService } from './toolbar.service';

@NgModule({
  declarations: [ToolbarComponent, AdminNotificationsToolbarComponent],
  imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatBadgeModule,
    MatTooltipModule,

    FuseSharedModule,
    FuseSearchBarModule,
    FuseShortcutsModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
  ],
  exports: [ToolbarComponent, AdminNotificationsToolbarComponent],
  providers: [ProfileService, ToolbarService],
})
export class ToolbarModule {}
